// Importing action types and initial state
import * as types from "../Actions/ActionTypes";
import initialState from "./initailState";

// Reducer function to manage payout-related state
const payout = (state = initialState.payout, action) => {
  switch (action.type) {
    // Handle API call for getting the last calculation date
    case types.GET_PAYOUT_LASTCALCDATE_CALL:
      return { ...state, loading: true };

    // Handle successful response for the last calculation date
    case types.GET_PAYOUT_LASTCALCDATE_SUCCESS:
      return { ...state, loading: false, lastCalcDate: action.data };

    // Handle error response for the last calculation date
    case types.GET_PAYOUT_LASTCALCDATE_ERROR:
      return { ...state, error: true, loading: false };

    // Default case to return the current state
    default:
      return state;
  }
};

// Exporting the reducer as the default export
export default payout;
